<div class="sw-cms-el-preview-product-finder">
    <div class="product-finder-preview-container">
        <div class="preview-icon">
            <mt-icon name="regular-search" size="32px"></mt-icon>
        </div>
        
        <div class="preview-content">
            <h3>{{ $tc('sw-cms.elements.productFinder.preview.title') }}</h3>
            <p>{{ $tc('sw-cms.elements.productFinder.preview.description') }}</p>
{#             
            <div class="preview-steps">
                <div class="step-item">
                    <span class="step-number">1</span>
                    <span class="step-text">{{ $tc('sw-cms.elements.productFinder.preview.stepExample1') }}</span>
                </div>
                <div class="step-item">
                    <span class="step-number">2</span>
                    <span class="step-text">{{ $tc('sw-cms.elements.productFinder.preview.stepExample2') }}</span>
                </div>
                <div class="step-item">
                    <span class="step-number">3</span>
                    <span class="step-text">{{ $tc('sw-cms.elements.productFinder.preview.stepExample3') }}</span>
                </div>
            </div>
            
            <div class="preview-button">
                <span class="fake-button">{{ $tc('sw-cms.elements.productFinder.preview.startButton') }}</span>
            </div> #}
        </div>
    </div>
</div>